import cn from 'classnames';
import { CheckBox } from 'components/UtilElements';
import * as dt from 'core/datetime';
import { DATE_FORMAT } from 'globals/constants';

import { getColorClassForPercentage } from './helpers';

export interface QuizScoresProps {
  quizzes: BulkActivityScore[];
  selectedQuizIds: string[];
  toggleSelectedQuizId: (quizId: string) => void;
}

const QuizScores = ({ quizzes, selectedQuizIds, toggleSelectedQuizId }: QuizScoresProps) => {
  return (
    <table className='table table--bordered activity__bulk-export-score-table'>
      <tbody>
        {quizzes.map((quiz) => {
          const isSelected = selectedQuizIds.includes(quiz.activityId);
          return (
            <tr
              key={quiz.activityId}
              className={cn('gutters', 'clickable', 'backgroundColorWhite', { selected: isSelected })}
              onClick={() => toggleSelectedQuizId(quiz.activityId)}
            >
              <td>
                <CheckBox isChecked={isSelected} readonly />
              </td>
              <td>
                <div className='table__cell'>
                  <div className='table__cell-header table__cell-header--title'>{`Quiz ${quiz.activityNum}`}</div>
                  <div className='table__cell-value table__cell-value--sm'>{quiz.title}</div>
                </div>
              </td>
              <td>
                <div className='table__cell'>
                  <div
                    className={cn('tag', {
                      'tag--green': quiz.toBeDone === 'inClass',
                      'tag--blue': quiz.toBeDone === 'preClass',
                    })}
                  >
                    {quiz.toBeDone === 'inClass' ? 'IN CLASS' : 'PRE CLASS'}
                  </div>
                  <div className='table__cell-value table__cell-value--no-wrap'>
                    {dt.format(quiz.dueDateTime, DATE_FORMAT)}
                  </div>
                </div>
              </td>
              <td>
                <div className='table__cell'>
                  <div className='table__cell-header'>SUBMISSIONS</div>
                  <div className='table__cell-value'>{quiz.numSubmissions}</div>
                </div>
              </td>
              <td>
                <div className='table__cell'>
                  <div className='table__cell-header'>AVERAGE SCORE</div>
                  <div>
                    {quiz.hasScore ? (
                      <span className={getColorClassForPercentage(quiz.avgScore)}>{quiz.avgScore}%</span>
                    ) : (
                      '--'
                    )}
                  </div>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default QuizScores;
